import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { formatApiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", password: "", phone: "", role: "agent", agency_name: ""
  });
  const [loading, setLoading] = useState(false);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const user = await register(form);
      toast.success(`Akun ${user.name} berhasil dibuat`);
      navigate("/app/dashboard");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10 bg-[#0A0D14] text-slate-100">
      <div className="w-full max-w-md">
        <Link to="/" className="flex justify-center mb-8" data-testid="register-logo">
          <Brand className="h-36" />
        </Link>
        <div className="rounded-2xl border border-white/10 bg-[#141C2E] p-8">
          <h1 className="text-2xl font-bold">Buat akun agent</h1>
          <p className="text-sm text-slate-400 mt-1">Gratis 30 hari semua fitur, tanpa kartu kredit.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <Label className="text-slate-300">Nama Lengkap</Label>
              <Input required value={form.name} data-testid="register-name-input"
                     onChange={(e) => set("name", e.target.value)}
                     className="mt-1 bg-[#0D1322] border-white/10" placeholder="Budi Santoso" />
            </div>
            <div>
              <Label className="text-slate-300">Email</Label>
              <Input required type="email" inputMode="email" autoComplete="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} value={form.email} data-testid="register-email-input"
                     onChange={(e) => set("email", e.target.value.replace(/^mailto:/i, ""))}
                     className="mt-1 bg-[#0D1322] border-white/10" placeholder="agent@contoh.com" />
            </div>
            <div>
              <Label className="text-slate-300">Password</Label>
              <Input required type="password" minLength={6} value={form.password} data-testid="register-password-input"
                     onChange={(e) => set("password", e.target.value)}
                     className="mt-1 bg-[#0D1322] border-white/10" placeholder="min 6 karakter" />
            </div>
            <div>
              <Label className="text-slate-300">No. WhatsApp</Label>
              <Input type="tel" inputMode="tel" autoComplete="tel" value={form.phone} data-testid="register-phone-input"
                     onChange={(e) => set("phone", e.target.value)}
                     className="mt-1 bg-[#0D1322] border-white/10" placeholder="+6281234567890" />
            </div>
            <div>
              <Label className="text-slate-300">Tipe Akun</Label>
              <Select value={form.role} onValueChange={(v) => set("role", v)}>
                <SelectTrigger data-testid="register-role-select" className="mt-1 bg-[#0D1322] border-white/10">
                  <SelectValue />
                </SelectTrigger>
                <SelectContent className="bg-[#141C2E] border-white/10 text-slate-100">
                  <SelectItem value="agent">Agent Individu</SelectItem>
                  <SelectItem value="agency">Agency / Tim</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <Label className="text-slate-300">Nama Agency (opsional)</Label>
              <Input value={form.agency_name} data-testid="register-agency-input"
                     onChange={(e) => set("agency_name", e.target.value)}
                     className="mt-1 bg-[#0D1322] border-white/10" placeholder="Properti Jaya Group" />
            </div>
            <Button type="submit" disabled={loading} data-testid="register-submit-btn"
                    className="w-full bg-gradient-to-r from-[#FF5722] to-[#F97316] hover:from-[#F97316] hover:to-[#EA580C] font-semibold py-6">
              {loading ? "Memproses…" : "Buat Akun"}
            </Button>
          </form>
          <div className="mt-5 text-sm text-slate-400 text-center">
            Sudah punya akun?{" "}
            <Link to="/login" className="text-orange-400 hover:text-orange-300 font-medium" data-testid="register-to-login">
              Masuk
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
